"use strict";

var _classCallCheck = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
exports.__esModule = true;
exports.NumberLocalizer = exports.DateLocalizer = void 0;
var _dates = _interopRequireDefault(require("./dates"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// assumes both are supported or none
var supportStyles = false;
new Intl.DateTimeFormat(undefined, {
  // @ts-ignore
  get dateStyle() {
    supportStyles = true;
  }
});
var dateShort = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
};
var timeShort = {
  hour: 'numeric',
  minute: 'numeric'
};
var getFormatter = function getFormatter(culture, options) {
  return Intl.DateTimeFormat(culture, options).format;
};
/**
 * A `react-widgets` Localizer using native `Intl` APIs.
 *
 */
var IntlDateLocalizer = /*#__PURE__*/function () {
  function IntlDateLocalizer() {
    var _this = this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$culture = _ref.culture,
      culture = _ref$culture === void 0 ? undefined : _ref$culture,
      _ref$firstOfWeek = _ref.firstOfWeek,
      firstOfWeek = _ref$firstOfWeek === void 0 ? 0 : _ref$firstOfWeek;
    _classCallCheck(this, IntlDateLocalizer);
    this.culture = culture;
    this.firstOfWeek = function () {
      return firstOfWeek;
    };
    function normalizeFormat(date, format) {
      return typeof format === 'function' ? format(date, culture) : date.toLocaleString(culture, format);
    }
    var formats = {
      date: getFormatter(culture,
      // @ts-ignore
      supportStyles ? {
        dateStyle: 'short'
      } : dateShort),
      time: getFormatter(culture,
      // @ts-ignore
      supportStyles ? {
        timeStyle: 'short'
      } : timeShort),
      datetime: getFormatter(culture,
      // @ts-ignore
      supportStyles ? {
        dateStyle: 'short',
        timeStyle: 'short'
      } : Object.assign({}, dateShort, timeShort)),
      header: getFormatter(culture, {
        month: 'short',
        year: 'numeric'
      }),
      weekday: getFormatter(culture, {
        weekday: 'narrow'
      }),
      dayOfMonth: getFormatter(culture, {
        day: '2-digit'
      }),
      month: getFormatter(culture, {
        month: 'short'
      }),
      year: getFormatter(culture, {
        year: 'numeric'
      }),
      decade: function decade(date) {
        return "".concat(_this.year(date), " - ").concat(_this.year(_dates.default.endOf(date, 'decade')));
      },
      century: function century(date) {
        return "".concat(_this.year(date), " - ").concat(_this.year(_dates.default.endOf(date, 'century')));
      }
    };
    Object.keys(formats).forEach(function (key) {
      _this[key] = function (date, format) {
        return format ? normalizeFormat(date, format) : formats[key](date);
      };
    });
  }
  _createClass(IntlDateLocalizer, [{
    key: "toFormattedParts",
    value: function toFormattedParts(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        dateStyle: 'short',
        timeStyle: 'short'
      };
      return Intl.DateTimeFormat(this.culture, format).formatToParts(date).filter(function (p) {
        return p.type !== 'timeZoneName';
      });
    }
  }, {
    key: "parse",
    value: function parse(value) {
      var date = new Date(value);
      return isNaN(+date) ? null : date;
    }
  }]);
  return IntlDateLocalizer;
}();
exports.DateLocalizer = IntlDateLocalizer;

/**
 * A number localization strategy based on `Intl.NumberFormat`.
 */
var IntlNumberLocalizer = /*#__PURE__*/function () {
  function IntlNumberLocalizer() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$culture = _ref2.culture,
      culture = _ref2$culture === void 0 ? undefined : _ref2$culture;
    _classCallCheck(this, IntlNumberLocalizer);
    var _$toLocaleString$m;
    this.culture = culture;
    var decimal = 'formatToParts' in Intl.NumberFormat(culture) ? Intl.NumberFormat(culture).formatToParts(1.1)[1].value : ((_$toLocaleString$m = 1.1.toLocaleString(culture).match(/[^\d]/)) == null ? void 0 : _$toLocaleString$m[0]) || '.';
    var formatter = Intl.NumberFormat(culture).format;
    this.decimalCharacter = function () {
      return decimal;
    };
    this.format = function (num, format) {
      if (format) {
        return typeof format === 'function' ? format(num, culture) : num.toLocaleString(culture, format);
      }
      return formatter(num);
    };
  }
  _createClass(IntlNumberLocalizer, [{
    key: "parse",
    value: function parse(value) {
      return parseFloat(value.replace(this.decimalCharacter(), '.'));
    }
  }]);
  return IntlNumberLocalizer;
}();
exports.NumberLocalizer = IntlNumberLocalizer;